/* Extracted from productpage.html and adapted for Shopify */
(function(){
    // ===== Gallery thumbnails =====
    const mainImg = document.getElementById('mainImg');
    const thumbs = Array.from(document.querySelectorAll('.thumb'));
  
    if (mainImg) {
      thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-src');
          const alt = btn.getAttribute('data-alt') || 'Product image';
          if (!src) return;
  
          mainImg.src = src;
          mainImg.alt = alt;
  
          thumbs.forEach(t => t.setAttribute('aria-current', 'false'));
          btn.setAttribute('aria-current', 'true');
        });
      });
    }
  
    // ===== Quantity =====
    const qtyInput = document.getElementById('qtyInput');
    const minus = document.getElementById('qtyMinus');
    const plus = document.getElementById('qtyPlus');
  
    if (qtyInput) {
      const clampQty = () => {
        let v = Number(qtyInput.value);
        if (!Number.isFinite(v) || v < 1) v = 1;
        qtyInput.value = String(Math.floor(v));
      };
  
      if (minus) {
        minus.addEventListener('click', () => {
          clampQty();
          qtyInput.value = String(Math.max(1, Number(qtyInput.value) - 1));
        });
      }
  
      if (plus) {
        plus.addEventListener('click', () => {
          clampQty();
          qtyInput.value = String(Number(qtyInput.value) + 1);
        });
      }
  
      qtyInput.addEventListener('input', clampQty);
      qtyInput.addEventListener('blur', clampQty);
    }
  
    // ===== Toast + Add to cart (demo hook) =====
    const toast = document.getElementById('toast');
    let toastTimer = null;
  
    const showToast = (msg) => {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('show'), 1400);
    };
  
    /* Note regarding Add to Cart:
       In Shopify, the form submission is typically handled by the form action itself.
       If AJAX add to cart is required, we would intercept the submit here.
       For now, we will leave the standard form submission but keep the toast for sticky bar or if we prevent default.
    */
    
    // Sticky Mobile Bar
    const stickyBar = document.getElementById('stickyBar');
    const purchaseBlock = document.querySelector('.purchase');
    const stickyAdd = document.getElementById('stickyAdd');
    const mainAddToCart = document.getElementById('addToCart');
  
    if (stickyBar && purchaseBlock) {
      const onScroll = () => {
        const r = purchaseBlock.getBoundingClientRect();
        const passed = r.bottom < 0; // scrolled past
        stickyBar.classList.toggle('show', passed);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
  
      // Connect sticky add to cart to main add to cart
      if (stickyAdd && mainAddToCart) {
        stickyAdd.addEventListener('click', () => {
            mainAddToCart.click();
        });
      }
    }
  
    // ===== Size chart modal =====
    const openSize = document.getElementById('openSizeChart');
    const modal = document.getElementById('sizeModal');
    const closeSize = document.getElementById('closeSize');
    const backdrop = document.getElementById('sizeBackdrop');
  
    if (modal) {
      const openModal = () => {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeSize) closeSize.focus();
      };
      const closeModal = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (openSize) openSize.focus();
      };
  
      if (openSize) openSize.addEventListener('click', openModal);
      if (closeSize) closeSize.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);
  
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
      });
    }

    // ===== Variant Picker =====
    const variantPickers = document.querySelectorAll('.variant-picker[data-section]');

    variantPickers.forEach(picker => {
      const sectionId = picker.dataset.section;
      const jsonEl = document.getElementById('ProductVariants-' + sectionId);
      if (!jsonEl) return;

      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        console.error('Failed to parse variant JSON', e);
        return;
      }

      // Cache currency symbol from initial price on page
      let currencySymbol = '$';
      const initialPriceEl = document.querySelector('.price');
      if (initialPriceEl) {
        const match = initialPriceEl.textContent.trim().match(/^([^\d]*)/);
        if (match && match[1]) currencySymbol = match[1];
      }

      // Cache the add-to-cart SVG icon by cloning it once
      const addBtn = document.getElementById('addToCart');
      let cartIconSvg = null;
      if (addBtn) {
        const svgEl = addBtn.querySelector('svg');
        if (svgEl) cartIconSvg = svgEl.cloneNode(true);
      }

      // Build current selection from active buttons in each group
      const getSelectedOptions = () => {
        const groups = picker.querySelectorAll('.variant-group');
        const selected = [];
        groups.forEach(group => {
          const active = group.querySelector('.is-active');
          selected.push(active ? active.dataset.optionValue : null);
        });
        return selected;
      };

      // Find matching variant from selected options
      const findVariant = (selectedOptions) => {
        return variants.find(v => {
          return selectedOptions.every((opt, i) => {
            if (!opt) return true;
            return v.options[i] === opt;
          });
        });
      };

      // Format money (cents to formatted string)
      const formatMoney = (cents) => {
        const amount = (cents / 100).toFixed(2);
        return currencySymbol + amount;
      };

      // Update UI when variant changes
      const updateVariant = (variant) => {
        if (!variant) return;

        // Update hidden form input
        const formInput = document.querySelector('#product-form input[name="id"]');
        if (formInput) {
          formInput.value = variant.id;
        }

        // Update main price row
        const priceEl = document.querySelector('.price');
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }

        // Update selected variant price below the picker
        const variantPriceEl = document.getElementById('VariantPrice-' + sectionId);
        if (variantPriceEl) {
          variantPriceEl.textContent = formatMoney(variant.price);
          // Add a brief flash animation
          variantPriceEl.classList.remove('price-updated');
          void variantPriceEl.offsetWidth; // force reflow
          variantPriceEl.classList.add('price-updated');
        }

        // Update stock status
        const statusEl = document.querySelector('.status');
        if (statusEl) {
          if (variant.available) {
            statusEl.innerHTML = '<span class="dot" aria-hidden="true"></span> In stock';
          } else {
            statusEl.textContent = 'Out of stock';
          }
        }

        // Update add to cart button (using cached SVG clone)
        if (addBtn) {
          addBtn.innerHTML = '';
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.appendChild(document.createTextNode('Add to cart '));
          } else {
            addBtn.disabled = true;
            addBtn.appendChild(document.createTextNode('Sold Out '));
          }
          if (cartIconSvg) {
            addBtn.appendChild(cartIconSvg.cloneNode(true));
          }
        }

        // Update sticky bar price
        const stickyPriceEl = document.querySelector('.sticky-price');
        if (stickyPriceEl) {
          stickyPriceEl.textContent = formatMoney(variant.price);
        }

        // Update main image if variant has a featured image
        if (variant.featured_image && mainImg) {
          const newSrc = variant.featured_image.src;
          if (newSrc) {
            mainImg.src = newSrc;
            mainImg.alt = variant.featured_image.alt || variant.title;
            // Highlight matching thumbnail
            thumbs.forEach(t => {
              const thumbSrc = t.getAttribute('data-src') || '';
              const normalize = (s) => s.split('?')[0].replace(/_\d+x\d*|_\d*x\d+/g, '');
              const isMatch = normalize(thumbSrc) === normalize(newSrc);
              t.setAttribute('aria-current', isMatch ? 'true' : 'false');
            });
          }
        }

        // Update URL without page reload
        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        // Update option labels with selected value
        const groups = picker.querySelectorAll('.variant-group');
        groups.forEach((group, i) => {
          const label = document.getElementById('OptionLabel-' + i + '-' + sectionId);
          if (label && variant.options[i]) {
            label.textContent = variant.options[i];
          }
        });
      };

      // Handle clicks on pills and swatches using event delegation
      picker.addEventListener('click', (e) => {
        const btn = e.target.closest('.variant-pill, .variant-color-swatch');
        if (!btn) return;

        const optionIndex = parseInt(btn.dataset.optionIndex, 10);
        const group = picker.querySelector('.variant-group[data-option-index="' + optionIndex + '"]');
        if (!group) return;

        // Only deselect within THIS group
        group.querySelectorAll('.variant-pill, .variant-color-swatch').forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });

        // Select the clicked button
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        // Find and apply the matching variant
        const selectedOptions = getSelectedOptions();
        const matchedVariant = findVariant(selectedOptions);

        if (matchedVariant) {
          updateVariant(matchedVariant);
        }
      });
    });
  })();

